export const projectsBase = {
	complete: [
		{
			id: 1,
			name: "projects.sportif.name",
			preview: "../images/projects/sportif.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.sportif.desc",
			link: "https://toha-web.github.io/Sportif/",
		},
		{
			id: 2,
			name: "projects.rick.name",
			preview: "../images/projects/rick&morty.jpg",
			tech: ["HTML", "CSS", "JS", "React", "MUI"],
			desc: "projects.rick.desc",
			link: "https://rick-morty-fun.vercel.app/",
		},
		{
			id: 3,
			name: "projects.portfolio.name",
			preview: "../images/projects/portfolio.jpg",
			tech: ["HTML", "SCSS", "JS", "React"],
			desc: "projects.portfolio.desc",
		},
		{
			id: 4,
			name: "projects.pipoo.name",
			preview: "../images/projects/pipoo.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.pipoo.desc",
			link: "https://pi-poo.vercel.app/",
		},
		{
			id: 5,
			name: "projects.aesthetic.name",
			preview: "../images/projects/aesthetic.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.aesthetic.desc",
			link: "https://toha-web.github.io/aesthetic/",
		},
	],
	small: [
		{
			id: 1,
			name: "projects.mill.name",
			preview: "../images/projects/mill.jpg",
			tech: ["HTML", "CSS"],
			desc: "projects.mill.desc",
			link: "https://toha-web.github.io/animation-mill/",
		},
		{
			id: 2,
			name: "projects.list.name",
			preview: "../images/projects/list.jpg",
			tech: ["HTML", "CSS", "JS", "React"],
			desc: "projects.list.desc",
			link: "https://toha-web.github.io/shopping-list/",
		},
		{
			id: 3,
			name: "projects.editor.name",
			preview: "../images/projects/editor.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.editor.desc",
			link: "https://toha-web.github.io/OnlineEmmetEditor/",
		},
		{
			id: 4,
			name: "projects.saper.name",
			preview: "../images/projects/saper.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.saper.desc",
			link: "https://toha-web.github.io/minesweeper/",
		},
		{
			id: 5,
			name: "projects.animtext.name",
			preview: "../images/projects/animText.jpg",
			tech: ["JS"],
			desc: "projects.animtext.desc",
			link: "https://toha-web.github.io/animated-text/",
		},
		{
			id: 6,
			name: "projects.tetris.name",
			preview: "../images/projects/tetris.jpg",
			tech: ["HTML", "CSS", "JS"],
			desc: "projects.tetris.desc",
			link: "https://toha-web.github.io/tetris/",
		},
		{
			id: 7,
			name: "projects.burger.name",
			preview: "../images/projects/burger.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.burger.desc",
			link: "https://toha-web.github.io/burger-constructor/",
		},
		{
			id: 8,
			name: "projects.joker.name",
			preview: "../images/projects/joker.jpg",
			tech: ["HTML", "CSS", "JS"],
			desc: "projects.joker.desc",
			link: "https://toha-web.github.io/joker/",
		},
	],
	test: [
		{
			id: 1,
			name: "projects.cards.name",
			preview: "../images/projects/cards.jpg",
			tech: ["HTML", "CSS"],
			desc: "projects.cards.desc",
			link: "https://toha-web.github.io/serviceCards/",
		},
		{
			id: 2,
			name: "projects.rect.name",
			preview: "../images/projects/rect.jpg",
			tech: ["HTML", "CSS", "JS", "React"],
			desc: "projects.rect.desc",
			link: "https://toha-web.github.io/test-task/",
		},
		{
			id: 3,
			name: "projects.vimeo.name",
			preview: "../images/projects/vimeo.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.vimeo.desc",
			link: "https://toha-web.github.io/vimeo-slider/",
		},
		{
			id: 4,
			name: "projects.accordeon.name",
			preview: "../images/projects/accordeon.jpg",
			tech: ["HTML", "SCSS", "JS"],
			desc: "projects.accordeon.desc",
			link: "https://toha-web.github.io/accordeon/",
		},
		{
			id: 5,
			name: "projects.plerdy.name",
			preview: "../images/projects/friends.jpg",
			tech: ["HTML", "CSS", "JS"],
			desc: "projects.plerdy.desc",
			link: "https://toha-web.github.io/test-friends/",
		},
		{
			id: 6,
			name: "projects.pet.name",
			preview: "../images/projects/pet.jpg",
			tech: ["HTML", "CSS", "JS"],
			desc: "projects.pet.desc",
			link: "https://toha-web.github.io/pet-naturals/",
		},
		{
			id: 7,
			name: "projects.charts.name",
			preview: "../images/projects/charts.png",
			tech: ["Vue", "PrimeVue", "ApexCharts", "Charts.js"],
			desc: "projects.charts.desc",
			link: "https://mlops-charts.vercel.app/",
		},
	],
};
